import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL } from "constants";

// Define the metadata-related API endpoints
export const metadataApi = createApi({
  reducerPath: "metadataApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
  }),
  tagTypes: ["Metadata"],
  endpoints: (builder) => ({
    getMetadata: builder.query({
      query: ({ projectId }) => `metadata/${projectId}`,
    }),
  }),
});

export const { useGetMetadataQuery } = metadataApi;
export default metadataApi;
